"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MontageSetOpti = void 0;
var MontageSetOpti;
(function (MontageSetOpti) {
    MontageSetOpti[MontageSetOpti["WANDKONSOLE_EINZELND"] = 1611] = "WANDKONSOLE_EINZELND";
    MontageSetOpti[MontageSetOpti["MONTAGE_SET_MIT_C_PROFIL"] = 1522] = "MONTAGE_SET_MIT_C_PROFIL";
    MontageSetOpti[MontageSetOpti["MONTAGE_SET_OHNE_C_PROFIL"] = 1523] = "MONTAGE_SET_OHNE_C_PROFIL";
    MontageSetOpti[MontageSetOpti["END_SET_MIT_C_PROFIL"] = 1524] = "END_SET_MIT_C_PROFIL";
    MontageSetOpti[MontageSetOpti["END_SET_OHNE_C_PROFIL"] = 1525] = "END_SET_OHNE_C_PROFIL";
    MontageSetOpti[MontageSetOpti["SCHRAUBENSATZ"] = 1530] = "SCHRAUBENSATZ";
    MontageSetOpti[MontageSetOpti["MONTAGE_SET_MIT_DISTANZPLATTE"] = 1531] = "MONTAGE_SET_MIT_DISTANZPLATTE";
    MontageSetOpti[MontageSetOpti["MONTAGE_SET_OHNE_DISTANZPLATTE"] = 1532] = "MONTAGE_SET_OHNE_DISTANZPLATTE";
    MontageSetOpti[MontageSetOpti["OHNE_C_PROFIL_ALLE_BREITEN"] = 1578] = "OHNE_C_PROFIL_ALLE_BREITEN";
    MontageSetOpti[MontageSetOpti["BEFESTIGUNG_INNEN_MIT_C_PROFIL"] = 1579] = "BEFESTIGUNG_INNEN_MIT_C_PROFIL";
    MontageSetOpti[MontageSetOpti["BEFESTIGUNG_AUSSEN_MIT_C_PROFIL"] = 1580] = "BEFESTIGUNG_AUSSEN_MIT_C_PROFIL";
    MontageSetOpti[MontageSetOpti["BEFESTIGUNGSSATZ"] = 1526] = "BEFESTIGUNGSSATZ";
})(MontageSetOpti = exports.MontageSetOpti || (exports.MontageSetOpti = {}));
//# sourceMappingURL=montage-set-opti.js.map